import {Pipe, PipeTransform} from '@angular/core';
import {shortenWalletAddress} from './dyn-xyz-utils';

@Pipe({
    name: 'shortenWalletAddr'
})
export class ShortenWalletAddrPipe implements PipeTransform {

    public transform(fullAddress: string) {
        return shortenWalletAddress(fullAddress);
    }

}
